/**
 * End and start parameters must be momentJS instances
**/
export default function (start, end) {
    const duration = end.diff(start, 'minutes');

    if (duration <= 0) {
        return 0;
    }

    let minutes = 0;
    let hours = Math.floor(duration / 60);

    if (hours >= 1 && duration >= 60) {
        let remainder = duration % 60;
        minutes = (remainder * 100 / 60) / 100; // convert minutes to decimal
    } else {
        minutes = (duration * 100 / 60) / 100; // convert minutes to decimal
    }

    return  hours + minutes;
}